import { getConfig } from "@lib/use_config";

interface Config {
  id: number;
  allowRouteLevelLocations: string;
}

interface Query {
  config: Config;
}

// Validates a location. Primarily ensures that the location is not
// too broad. Only validates google-sourced locations. The assumption is
// that if this is a Hudson-sourced location then it's probably fine.
async function isValidLocation(location: be.Location): Promise<boolean> {
  if (location?.googleObj == undefined || location.googleObj.secondChanceFkl) return true;

  const { data } = await getConfig(["allowRouteLevelLocations"]);

  // Grab and normalize address types.
  const comps: Record<string, string> = {},
    shortNameComps = ["route", "administrative_area_level_1", "country"];
  location.googleObj.address_components?.forEach(function (comp) {
    const compType: string = comp.types[0];
    comps[compType] = shortNameComps.includes(compType) ? comp.short_name : comp.long_name;

    // Special case for NY boroughs.
    if (comp.types.includes("sublocality_level_1")) comps.sublocality_level_1 = comp.short_name;
  });

  // Is this too general? Is that ok?
  const isRoute = location.googleObj.types?.includes("route"),
    isSpecificEnough =
      (data?.config.allowRouteLevelLocations && isRoute) ||
      location.googleObj.types?.some((t) =>
        [
          "street_address",
          "establishment",
          "point_of_interest",
          "premise",
          "intersection",
          "subpremise",
          "airport",
          "park",
        ].includes(t),
      );

  return !!isSpecificEnough;
}

export default isValidLocation;
